import WordLogoSrc from 'assets/images/logo-large@2x.png';
import type { FC } from 'react';
import AccountableLogoWordV2 from '../SVG/AccountableLogoWordV2';
import AccountableIcon from '../SVG/Logo';
import type AccountableLogoProps from './AccountableLogo.types';
const AccountableLogo: FC<AccountableLogoProps> = ({
  className,
  type = 'word',
  ...props
}) =>
  type === 'word' ? (
    <AccountableIcon
      className={className}
      color={props.color}
      {...(props as any)}
    />
  ) : type === 'wordV2' ? (
    <AccountableLogoWordV2
      className={className}
      color={props.color}
      {...(props as any)}
    />
  ) : (
    <img
      src={WordLogoSrc}
      alt="Accountable Logo"
      className={className}
      {...props}
    />
  );

export default AccountableLogo;
